import { createAction } from 'redux-starter-kit';
import api from 'api';
import { errHelper } from 'utils';
import usersApi from 'api/resources/user';
import env from 'consts/env';

export const SET_MESSAGE = 'ws/set-message';
export const SET_MESSAGES = 'ws/set-messages';

const setMessages = createAction(SET_MESSAGES);
const setMessage = createAction(SET_MESSAGE);

const wsUrl = env.API_ENDPOINT ? env.API_ENDPOINT.replace('http', 'ws') : '';

export const webSocketActions = {
  setMessages,
  startWebsocketConnection: () => (dispatch: any) => {
    return usersApi
      .getUserProfile()
      .then(user => {
        return api.getMessages(user.data.id).then(messages => {
          //@ts-ignore
          dispatch(setMessages(messages.data.results));

          let ws = new WebSocket(
            `${wsUrl}/api/v1/${user.data.organization.schema.replace(
              /\s/g,
              '_'
            )}/ws/${user.data.id}/`
          );

          const onMessage = (e: any) => {
            // eslint-disable-next-line
            console.log(e.data);
            dispatch(setMessage(JSON.parse(e.data)));
          };
          //@ts-ignore
          ws.onmessage = (e: any) => {
            onMessage(e);
          };
          //@ts-ignore
          ws.onclose = () => {
            if (user && user.data && user.data.id) {
              //@ts-ignore
              ws = new WebSocket(
                `${wsUrl}/api/v1/${user.data.organization.schema.replace(
                  /\s/g,
                  '_'
                )}/ws/${user.data.id}/`
              );
            }
          };
        });

        // setUser(user.data);
      })
      .catch((err: any) => errHelper(err));
  }
};
